module.exports = __webpack_public_path__ + "img/blank_pages_thumb.ae0ef3cb.jpg";